import { Injectable } from '@angular/core';

import { State, Action, StateContext, Selector, StateToken } from '@ngxs/store';

import {
  SetCartLoadingAction,
  ToggleCartDrawerAction
} from './cart-ui.actions';
import { CartUIStateModel } from './cart-ui.model';

const CART_UI_TOKEN = new StateToken<CartUIStateModel>('cartUI');

@State<CartUIStateModel>({
  name: CART_UI_TOKEN,
  defaults: {
    drawerOpen: false,
    isLoading: false
  }
})
@Injectable()
export class CartUIState {
  @Selector()
  static drawerOpen(state: CartUIStateModel): boolean {
    return state.drawerOpen;
  }

  @Selector()
  static isLoading(state: CartUIStateModel): boolean {
    return state.isLoading;
  }

  @Action(ToggleCartDrawerAction)
  toggleCartDrawer(
    ctx: StateContext<CartUIStateModel>,
    action: ToggleCartDrawerAction
  ) {
    const state = ctx.getState();
    const newState =
      typeof action.open !== 'undefined' ? action.open : !state.drawerOpen;
    ctx.patchState({ drawerOpen: newState });
  }

  @Action(SetCartLoadingAction) setCartLoading(
    ctx: StateContext<CartUIStateModel>,
    action: SetCartLoadingAction
  ) {
    ctx.patchState({ isLoading: action.isLoading });
  }
}
